import { Fragment, useState, useEffect } from 'react'
import { CiSearch } from "react-icons/ci";
import { IoMdMic } from "react-icons/io";
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { LuSearch } from "react-icons/lu";
import { FaMicrophone } from "react-icons/fa";
import { BiSearchAlt2 } from "react-icons/bi";
import { IoMicSharp } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom';
import { FaSquareXmark } from "react-icons/fa6";
import fetchApi from './Api';



function classNames(...classes) { 
  return classes.filter(Boolean).join(' ')
}

export default function Navbar({...props}) {



 

  const { setselectedCategory,selectedCategory, setBlur, page, setPage, setLoading, Loading,databaseDataLength,setDatabaseDataLength, VedioArr, AllFetchedData, setVedioArr,setAllFetchedData,displayName, setDisplayName} = props;

  

  let navigate = useNavigate();
  const [searchValue, setsearchValue] = useState('');

  const [transcript, setTranscript] = useState('')
  const [userName, setUserName] = useState("");
  const [mobileSearch, allowMobileSearch] = useState(false)


  const [selectedImage, setSelectedImage] = useState("https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80");


  const cheakForRequests = async(data)=>{

    if(data['totalRequest'] == 35)
    {
      setInterval(() => {
        alert("Please come back tommorrow!!!")
      }, 4000);

      return ;
    }

      if(data['totalRequest'] == 15 || data['totalRequest'] == 30 )
      { 
        try {

          let response = await fetch('https://play-tube-418206-default-rtdb.firebaseio.com/limitCross.json', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json"
            },
      
            body: JSON.stringify(data)
          })
          
          alert('You have crossed limit...')
        
        }
        catch(e){
            
        }
    
      }
    
  }


  useEffect(()=>{
    let data = JSON.parse(localStorage.getItem("userDetails"))
    
    
    
    // if(!data || data.name === null)
    //     {
    //       navigate('/details')
    //     }
      if(data && data.name)
        {
        
          setDisplayName(data?.name[0]?.toUpperCase())
          cheakForRequests(data);
        }

        


  },[selectedCategory])


  function cheakUserName(){
    const regex = /[^a-zA-Z]/g;
   
    return !regex.test(userName);
  }

 

  const GetFirebaseData = async () => {


  

    
    let response = await fetch('https://play-tube-418206-default-rtdb.firebaseio.com/MyData.json')
    response = await response.json();


    let newArray = [];

    for (let key in response) {

      // Check the condition for each value
      if (response[key].keywords.includes(searchValue)) {
        // Add the value to the new array if it matches the condition
        newArray.push(response[key]);
      }


    }
  
  
  
    // return [];

    return newArray.length === 0 ? null : newArray;
  }

  

  const addToDatabase = async (vidData) => {


  
  
    try {

      let response = await fetch('https://play-tube-418206-default-rtdb.firebaseio.com/MyData.json', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
  
        body: JSON.stringify(vidData)
      })
      
    
    }
    catch(e){

    }

    // if (response) {
  
    // }
    // else {
  
    // }


  }


  const filterCatgegoryOut = async () => {
    return await GetFirebaseData();
  }
  
 
  const submitInput = (e) => {
   
    let userDetails = JSON.parse(localStorage.getItem("userDetails"))
    cheakForRequests(userDetails);
    allowMobileSearch(false);
 
  
    setselectedCategory(searchValue);
    setsearchValue("")
    setLoading(true)
    setPage(0);
    setDatabaseDataLength(0);
    setAllFetchedData([]);
  
    let query = searchValue;
    let modifiedQuery = '';

      
  for(let i = 0; i < query.length; i++) {
    if(query[i] == ' ') {
      modifiedQuery += '+';
    } else {
      modifiedQuery += query[i];
    }
  }

  setselectedCategory(modifiedQuery);
  

  if(window.location.pathname === '/')
  {
  filterCatgegoryOut().then((data) => {

    if (data === null ) {

      try {

        // fetching data from V2

        fetchApi('search/?part=snippet', '&country=in&query=' + modifiedQuery + `&page=${page}`)
          .then((videos) => {

          
            // setFilterQueries({})

           
            let vidData = videos?.data?.videos;
          
          
            setVedioArr(vidData);

            setAllFetchedData(vidData);
            setDatabaseDataLength(vidData?.length);

          



            // adding data into database
            vidData?.forEach(ele => {
              // adding category
              ele.keywords.push(searchValue)

              


              addToDatabase(ele)
            });
            
            setLoading(false)
          })
      }
      catch (e) {
      
      }
    }
    else  {

      // AllFetchedData = data;

      //data found

    
      setAllFetchedData(data);
      

      setTimeout(() => {
        setLoading(false)
      }, Math.floor(Math.random() * 4))


      // setVedioArr(data.slice(databaseDataLength, databaseDataLength + 30));
      setVedioArr(data.slice(0, 30));
      // databaseDataLength += 30;
      // setDatabaseDataLength(databaseDataLength+30)
      setDatabaseDataLength(30)
    }

    userDetails['totalRequest']++;
    localStorage.setItem("userDetails", JSON.stringify(userDetails) )  ;

    
  })
    .catch()
  {
  
  }
}
else{
  navigate('/')
}
    
  }
 
  const submitMicInput = (searchValue) => {
   
    
    let userDetails = JSON.parse(localStorage.getItem("userDetails"))
    cheakForRequests(userDetails);
    allowMobileSearch(false);
 
  
    setselectedCategory(searchValue);
    setsearchValue("")
    setLoading(true)
    setPage(0);
    setDatabaseDataLength(0);
    setAllFetchedData([]);
  
    let query = searchValue;
    let modifiedQuery = '';

      
  for(let i = 0; i < query.length; i++) {
    if(query[i] == ' ') {
      modifiedQuery += '+';
    } else {
      modifiedQuery += query[i];
    }
  }

  setselectedCategory(modifiedQuery);
  

  if(window.location.pathname === '/')
  {
  filterCatgegoryOut().then((data) => {

    if (data === null ) {

      try {

        // fetching data from V2

        fetchApi('search/?part=snippet', '&country=in&query=' + modifiedQuery + `&page=${page}`)
          .then((videos) => {

          
            // setFilterQueries({})

           
            let vidData = videos?.data?.videos;
          
          
            setVedioArr(vidData);

            setAllFetchedData(vidData);
            setDatabaseDataLength(vidData?.length);

          



            // adding data into database
            vidData?.forEach(ele => {
              // adding category
              ele.keywords.push(searchValue)

              


              addToDatabase(ele)
            });
            
            setLoading(false)
          })
      }
      catch (e) {
      
      }
    }
    else  {

      // AllFetchedData = data;

      //data found

    
      setAllFetchedData(data);
      

      setTimeout(() => {
        setLoading(false)
      }, Math.floor(Math.random() * 4))


      // setVedioArr(data.slice(databaseDataLength, databaseDataLength + 30));
      setVedioArr(data.slice(0, 30));
      // databaseDataLength += 30;
      // setDatabaseDataLength(databaseDataLength+30)
      setDatabaseDataLength(30)
    }

    

  })
    .catch()
  {
  
  }
    userDetails['totalRequest']++;
    localStorage.setItem("userDetails", JSON.stringify(userDetails) )  ;
}
else{
  navigate('/')
}
    
  }

  function startListening() {

    if (typeof window === 'undefined') {
      alert("There is no support for speech!");
    }
    else if (!window.webkitSpeechRecognition) {
      alert("Sorry! Your PC doesn't support for speech.")
    }
    else {
      const recognition = new window.webkitSpeechRecognition();
      let speech = "";

      recognition.start();

      recognition.onstart = () => {
      
      };

      recognition.onresult = (event) => {
        speech = event.results[0][0].transcript;
        setsearchValue(event.results[0][0].transcript)
        submitMicInput(event.results[0][0].transcript)
      };

      recognition.onerror = (event) => {
        console.error('Recognition error:', event.error);
      };

      recognition.onend = () => {
      
        toggleMic(0);
        if(speech == '' || !speech)
          {
            alert('Unable to listen your voice. Please try again.')
          }
          else{
            setselectedCategory(speech);
          }
        // setselectedCategory(speech);

      };
    }
  }

  const clearData = ()=>{
    
    navigate('/');
    localStorage.removeItem('userDetails');
    window.location.reload();
    
    // setPopupVisible(true);
        // localStorage.getItem("userDetails")
  }

  const toggleMic = (flag) => {
    if (flag) {
      document.getElementById('cross1').classList.remove('none');
      document.getElementById('mic1').classList.remove('none');
      setBlur("ON");
      startListening();
    }
    else {
      document.getElementById('cross1').classList.add('none');
      document.getElementById('mic1').classList.add('none');
      setBlur("OFF");

    }

  }

  return (
    <Disclosure as="nav" className=" sticky top-0 z-30" style={{'backgroundColor':'#150507'}}>
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8   ">
            <div className="relative flex h-16 items-center justify-between ">
              {/* <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
               
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div> */}
              <div className="flex w-full items-center   justify-between">
                <Link to='/' className="flex flex-shrink-0 items-center">
                  <img
                    className="h-8 w-auto"
                    src="Playtubelogo.webp"
                    alt="PLAYTUBE" />
                  <span className="font-extrabold text-white">PLAY-TUBE</span>
                </Link>

                
                {/* for Mobile */}
                <form onSubmit={(e) => { e.preventDefault(); (searchValue !== "" && submitInput() )}} className="sm:hidden mr-4">
                  <button onClick={() => { allowMobileSearch(!mobileSearch) }}><CiSearch className="h-8 w-8 text-white  font-extrabold rounded-full" /></button>

                  {mobileSearch && <div className='absolute top-2 text-center left-0 w-full h-[100vh] bg-black'>
                    <input type="text" onChange={(e) => setsearchValue(e.target.value)} value={searchValue} className='border bg-gray-500 text-white   rounded-md mx-2 py-3 my-5 focus:border-red-800   w-[90%] px-5 mt-6 shadow-lg' placeholder='search...' />
                    <button onClick={() => { allowMobileSearch(!mobileSearch) }}><FaSquareXmark className='absolute top-1 right-1 hover:bg-red-600 bg-red-400  text-2xl' /></button>

                    <div className='h-full flex justify-center items-center '>
                        <IoMdMic onClick={startListening} className='  rounded-full p-1 w-12 h-12 bg-gray-700 text-white' />
                    </div>
                  </div>}

                </form>



                <form onSubmit={(e) => { e.preventDefault(); submitInput(); }} className="input sm:w-[55%] sm:flex hidden">
                  <input type="text" onChange={(e) => setsearchValue(e.target.value)} value={searchValue} className='  text-white border-none rounded-l-full h-10 focus:border-red-800   w-full px-5 shadow-lg' placeholder='search...' style={{'backgroundColor':'#2622237d'}}/>
                  <CiSearch onClick={() => { setselectedCategory(searchValue); setsearchValue(""); submitInput() }} className=' text-sm p-2 hover:bg-red-900  text-white w-12 h-10 font-bold rounded-r-full  ' style={{'backgroundColor':'#2622237d'}}/>
                  <FaMicrophone onClick={() => toggleMic(1)} className='ml-8  rounded-full text-gray-500  hover:text-red-500 p-1 w-10 h-10 text-sm' />
                </form>

                {/* for Mic */}
                
              
                <button id="cross1" onClick={() => toggleMic(0)} className="absolute z-50 top-[16.5rem] left-[47.5rem] text-xl p-1 bg-red-300 hover:bg-red-500 none" type="button">X</button>
                <div id="mic1" className="mic z-50 h-48 w-60 bg-white rounded-md shadow-xl absolute top-[16rem] left-[34rem] flex justify-center items-center none">
                  <div className=' top-9 flex justify-center items-center w-10 h-10 rounded-full bg-red-300  speak-container'>
                    <IoMicSharp className='text-4xl text-red-700' />
                    <p>Speak</p>
                  </div>
                </div>


                {/* for User Details */}
{/* 
                <div id="Details" className="mic z-40 h-60 w-80 bg-gray-500 rounded-md shadow-xl absolute top-[16rem] left-[34rem] flex justify-around item-center flex-col none">
                  <div className="flex flex-col mx-3 ">

                  
                        <label htmlFor="website-admin" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Enter Your Name</label>
                        <div className="flex">
                          <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600">
                            <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
                            </svg>
                          </span>
                          <input type="text" onChange={(e)=>setUserName(e.target.value)} id="website-admin" className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="elonmusk"/>
                        </div>
                    </div>
                <div className='flex justify-between mx-6'>
                  <button type="button" onClick={()=>addNameToDatabase()} class="focus:outline-none text-white bg-green-500 hover:bg-green-700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">Done</button>
                  <Link to="/userdetails" ><button type="button" class="py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">Add more details-&gt;</button></Link>
                </div>

        </div> */}


                {/* <div className="hidden sm:ml-6 sm:block">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                          'rounded-md px-3 py-2 text-sm font-medium'
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div> */}

                <div className="absolute  hidden sm:flex inset-y-0 right-0  items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">



                  <Menu as="div" className="relative ml-3   ">
                    <div>
                      <Menu.Button className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                        <span className="absolute -inset-1.5" />
                        <span className="sr-only">Open user menu</span>

                        {selectedImage ? (
                          // <div>
                          //   <img src={selectedImage} alt="Selected" className="h-8 w-8 rounded-full" />
                          // </div>
                          <div className={`h-8 w-8 flex items-center justify-center rounded-full bg-blue-300 text-black font-bold text-xl`}>
                            
                            {displayName}

                          </div>
                        ) : (<img
                          className="h-8 w-8 rounded-full"
                          src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                          alt=""
                        />)}
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute shadow-red-500 hover:shadow-lg bg-black top-[8rem] right-[26rem] z-10 mt-2 w-[26rem] h-fit  rounded-md  py-6 px-3 shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none space-y-5 text-white hover:text-gray-500 hover:font-bold ">
                        <Menu.Item>
                          {({ active }) => (
                            <div className='w-full flex flex-col justify-center items-center spaxe-y-2'>
                               <div className={`h-20  w-20 flex items-center justify-center rounded-full bg-green-500 text-black font-bold text-5xl`}>
                                {displayName}
                              </div>
                            </div>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <div>
                              
                            
                                <button
                                  onClick={() => navigate('/details')}

                                  className={classNames(active ? 'bg-gray-100' : '', 'w-full text-center px-4 py-2 text-sm  ')}
                                >
                                  Change Name

                                </button>
                                {/* <input type='text' id='changeName' placeholder='enter new name'/> */}
                            </div>
                          )}
                        </Menu.Item>
                      
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              onClick={clearData}
                              className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-center w-full ')}
                            >
                              Sign out
                            </button>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <Link 
                            to='/settings'

                              className={classNames(active ? 'bg-gray-100' : '', 'block h-50 w-50 bg-black  px-4 py-2 text-sm text-center mb-8')}
                            >
                              Settings
                            </Link>
                          )}
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </Menu>


                </div>

              </div>
            </div>
          </div>

          {/* <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                    'block rounded-md px-3 py-2 text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel> */}

        </>
      )}
    </Disclosure>
  )
}
